// 查询专题分类
import http from "@/utils/http";



export const queryVisitorMyApply = (pageIndex, keyword,openId,flowName,itemType) => http.get('nonlogin/visitor/application/applicatonList.htm', {
    pageIndex: pageIndex,
    pageSize: 20,
    openId:openId,
    keyword: keyword,
    flowName: flowName,
    itemType:itemType,
})
export const queryStatisticsMyApply = (pageIndex, openId) => http.get('nonlogin/edu/visitor/queryItemCountList.htm', {
    pageIndex: pageIndex,
    pageSize: 20,
    openId:openId,
})